import VideoFrame from './VideoFrame';

export default VideoFrame;
